<template>
    <div class="plans__container">
        <Card v-bind="options">
            <div class="period__switch">
                <PeriodToggle v-model="period" type="text" :label="{before:'Month', after :'Year'}" id="textype"/>
            </div>
            <div class="title__container">
                <span >{{data.title}}</span>
                <p v-html="data.description"></p>
            </div>
            <div class="packs__list">
                <div class="pack" v-for="(pack, index) in data.packs" :key="index" :style="pack.packName=='premium' ? ' height : 30rem;' : null">
                        <PlanCard v-bind="{...pack, period : period}" @handleclick="choosePack({...pack,period : period})"/>
                </div>
                <div class="credit__cards">
                    <span>+ More</span>
                </div>
            </div>
        </Card>
        <div class="title__container">
            <span>{{ data.compare_table.title }}</span>
        </div>
          <div class="table__container">
            <table>
                <thead>
                    <tr>
                        <th v-for="(col, index) in data.compare_table.columns" :key="index" :width="col.width" :style="`background-color:${col.color}`"> <span class="col__name">{{col.name}} </span></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr class="tbody" v-for="(item, itemIndex) in data.compare_table.elements" :key="itemIndex" :style="itemIndex % 2 == 0 ? 'background-color:#fff' :'background-color:#F2F2F2;'">
                            <td v-for="(col , colIndex) in data.compare_table.columns" :key="colIndex"  :style="{backgroundColor : col.key=='premium' ? itemIndex % 2 == 0 ? '#6D49A2': '#6d49a273' :null,color:  item.colors && item.colors[col.key] ? item.colors[col.key]: null}">
                                <div>
                                    <sup v-if="item['currency'] && col.key!='property'">{{item['currency']}}</sup>
                                    {{item[col.key] && typeof(item[col.key]) != 'boolean' ? item[col.key] : ""}}
                                    <span v-if="item['period'] && col.key!='property'">/{{period}}</span>
                                    <span class="check_icon" v-if="item[col.key] && typeof(item[col.key]) == 'boolean'">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="#51D879" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                             <td  class="tab__action" v-for="actionName in [null,'basic','pro','premium']" :key="actionName">
                                 <div>
                                    <Button v-if="actionName" v-bind="Object.assign(data.compare_table.actions[actionName],actionName == 'premium' ? premiumBtnStyle : {})"></Button>
                                 </div>
                            </td>
                        </tr>
                    </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Card from '../../../components/global/Card.vue';
    import PlanCard from '../../../components/global/PlanCard.vue';
    import PeriodToggle from '../../../components/global/Toggle.vue';
    import Button from '../../../components/global/Button.vue';
    export default {
        components : { Card, PlanCard, PeriodToggle, Button },
        data(){ 
            return { 
                period:'Month',
                    options :{
                        padding : { x : 0, y : 0},
                        rounded : .3,
                        boxShadow : {x : 5, y : 5, blur : 1.5, color : '#e5e5e526'},
                        hasfooter : false,
                        hasHeader : false,
                        boxShadow : { x : 1, y : 3, blur : 5.5, color : "#ccc"},         
                        bordered : false,
                        margin: "0",
                        height: 60,
                        main : { 
                            padding : { x : 0, y : 0},
                        },
                },
                data : {
                    title : "Plans and Pricing",
                    description : "More monthly uploads. large files. Private and password-protected sharing.</br>Custom backgrounds, environments, and much, much more when you upgrade.",
                    packs : [
                        {
                            packName : "BASIC",
                            price : 0,
                            currency : "$",
                            offersList : ["10 uploads / month"],
                            colors : {header : "#FF4F56", main : "white"} ,
                            button : {
                                name : "Sign up",
                                backgroundColor : "#FF4F56",
                                padding : {x:4, y:.8}
                            }
                                                    
                        },
                        {
                            packName : "Pro",
                            price : 9,
                            currency : "$",
                            colors : {header : "#4309B0", main : "white"} ,
                            offersList : ["50 uploads / month", "Private uploads"],
                            button : {
                                name : "Choose Plan",
                                backgroundColor : "#4309B0",
                                padding : {x:4, y:.8}
                            }
                                                    
                        },
                        {
                            packName : "premium",
                            price : 19,
                            currency : "$",
                            colors : {header : "#4309B0", main : "#6D49A2", mainText : "#fff"} ,
                            checkColor : "#fff",
                            offersList : ["250 uploads / month", "App-free AR", "Unbranded viewer", "15 seats"],
                            button : {
                                name : "Choose Plan",
                                backgroundColor : "#6D49A2",
                                bordered : true,
                                padding : {x:4, y:.8}
                            }
                                                    
                        },
                    ],
                    compare_table: {
                        title : "Compare all features",
                        actions : {
                            basic : {
                                name : "Sign up",
                                backgroundColor : "#FF4F56",
                                padding : {x:5, y:1}
                            },
                            pro : { 
                                name : "Choose Plan",
                                backgroundColor : "#4309B0",
                                padding : {x:5, y:1}
                            },
                            premium : { 
                                name : "Choose Plan",
                                backgroundColor : "#fff",
                                color: "#6D49A2",
                                bordered : true,
                                padding : {x:4, y:.5}
                            },
                        },
                        columns : [
                                    { 
                                        name : "",
                                        key : "property",
                                        width : "40%",
                                        color:"",
                                    },
                                    { 
                                        name : "BASIC",
                                        key : "basic",
                                        width : "20%",
                                        color:"#FF4F56",
                                    },
                                    { 
                                        name : "PRO",
                                        key : "pro",
                                        width : "20%",
                                        color:"#6D49A2",
                                    },
                                    { 
                                        name : "PREMIUM",
                                        key : "premium",
                                        width : "30%",
                                        color:"#32007D",
                                    },
                        ],
                        elements : [
                            {
                                property : "pricing table",
                                basic :"0",
                                period : "Month",
                                currency : "$",
                                pro :"9",
                                premium :"19",
                                colors : {
                                    basic : "#3D66FC",
                                    pro : "#3D66FC",
                                    property : "#3D66FC",
                                }
                            },
                            {
                                property : "Uploads/Months",
                                basic :"10",
                                pro :"50",
                                premium :"250",
                            },
                            {
                                property : "Maximum file size",
                                basic :"100MB",
                                pro :"200MB",
                                premium :"500MB",
                                colors : {
                                    basic : "#3D66FC",
                                    pro : "#3D66FC",
                                }
                            },
                            {
                                property : "Private Uploads",
                                basic :false,
                                pro :true,
                                premium :true,
                            },
                            {
                                property : "Partner network",
                                basic :true,
                                pro :true,
                                premium :true,
                            },
                            {
                                property : "Partner network",
                                basic :true,
                                pro :true,
                                premium :true,
                            },
                       
                        ]
                    }

                }
            }
        },
        computed : {
            premiumBtnStyle(){
               if(this.data.compare_table.elements.length % 2 == 0 )  return { color: "#fff",backgroundColor : "#6D49A2",padding : {x:5, y:1}};
               else  return { color: "#6D49A2",backgroundColor : "#fff",padding : {x:5, y:1}};
            }
        },
        methods :{
            choosePack(pack){console.log('pack----->', pack)}
        }
    }
</script>

<style lang="scss" scoped>
    .title__container {
        display  :flex;
        align-items :center;
        justify-content :center;
        flex-wrap: wrap;
        padding : 1rem 0 ;
        span {
            width : 100%;
            text-align: center;
            padding : 1rem 0 ;
            font-size: 2rem;
            font-weight: 600;
            color : #3D66FC;
        }
        p {
            font-size: 1.3rem;
            font-weight: 400;
            color : #262626;

        }
    }
    .period__switch {
        display: flex;
        align-items: center;
        justify-content:flex-end;
        padding-top : 1rem;
    }
    .packs__list {
        display :flex;
        align-items: center;
        justify-content:center;
        padding: 4rem 0;
        position: relative;
    }
    .pack {
        margin : 0 2rem;
    }
    .credit__cards {
        border: 1px solid #c1c2c4;
        border-radius: .2rem;;
        background-color: #F5F7FB;
        min-width: 50rem;
        padding : 1rem;
        position: absolute;
        bottom:-12rem;
        display:flex;
        align-items : center;
        justify-content : flex-end;
        span {
            font-weight: 500;
            font-size: 1.1rem;
        }
    }
    .table__container {
        display: flex;
        padding : 2rem 3rem;
    }
   table {
       width: 100%;
       thead {
           th { 
               padding : 1rem 1.5rem;
               text-align: center;
               color : #fff;
               font-size: 1.8rem;
               font-weight: 400;
               span {
                   width: 100%;
               }
           }
           th:nth-child(2) {
               border-top-left-radius: 1.5rem;
           }
           th:last-child {
               border-top-right-radius: 1.5rem;
           }
       }
   }
   tbody {
       td {
           div { 
                padding : 2rem 3rem;
                text-align: center;
           }
             border-right: 2px solid #E2E6F1;
       }
       td:first-child div {
           text-align: start;
           border-left: 2px solid #E2E6F1;
       }
       tr {
           font-size: 1.4rem;
           font-weight: 400;
        //    color : #717885;
           td:last-child {
               color : #fff !important;
            //    background-color : #6D49A2;
           }
         
       }
       tr:first-child {
            font-size: 2.5rem !important;
            border-top-left-radius: 1.5rem;
            // color : #3D66FC;
            font-weight: 600;
           td:first-child div  {
               border-top: 2px solid #E2E6F1;
               border-top-left-radius: 1.5rem;
               text-transform: uppercase;
           }
           td div {
               sup {
                   color : gray;
                   font-weight: 600;
                   font-size: 1.8rem;
               }
               span {
                   font-weight: 200;
                   font-size: 1.5rem;
               }
           }
           td:last-child div sup{ color:#fff;}
       }
       tr:last-child td  {
               border-bottom: 2px solid #E2E6F1;
           
       }
   }
   .tab__action div{
       display: flex;
       justify-content:center;
       align-items:center;
    //    padding : 1.5rem 2.4rem;
   }
   .check_icon {
       position: relative;
       z-index: 1;
       svg {
       width : 2.8rem;
       height : 2.8rem;
       }
       &:before {
           content : "";
           background-color : #fff;
           position : absolute;
           border-radius: 50%;
           width : 2rem;
           height : 2rem;
           left:.5rem;
           top:.1rem;
           z-index: -1;

       }


    
   }
</style>


// WEBPACK FOOTER //
// src/views/user_profile/company/plans.vue